import {TrackInfo} from "../../model/track-info";
import {TrackUtil} from "../../track-util";
import {TrackActionResult} from "../../model/track-action-result";

export class ProfessionalAction{

    // Id que não precisa de CNPJ
    static readonly notCompanyId = '11833';

    //página onde ocorre a ação
    static readonly actionPageId = 'profession';
    
    // Proxima pagina caso não precise de CNPJ
    static readonly incomeWealthincomePageId = 'income-wealthincome';

    // Proxima pagica caso <> Brasil 
    static readonly companyPageId = 'company-cnpj';

    // Paginas que serão removidas caso não precise de CNPJ
    static readonly removePages = [ProfessionalAction.companyPageId];

    
    
    public static execute(data: any, track: TrackInfo[], originalTracks: TrackInfo[]){
        track = TrackUtil.rebuildTracks(this.actionPageId, track, originalTracks);

        const id = data.professionalData.originIncome;

        if (id === this.notCompanyId) {
            return new TrackActionResult(data,
                track[track.findIndex(r => r.pageId === this.incomeWealthincomePageId)],
                track.filter(i => !this.removePages.includes(i.pageId)));
        } else {
            return new TrackActionResult(data,
                track[track.findIndex(r => r.pageId === this.companyPageId)],
                track);
        }
    }
}